<template>
  <div>
    <div v-if="!innerIsReview">
      <validation-provider
              v-slot="{ errors }"
              name="Image"
              rules="required"
              :vid="'validate-'+fieldAssignmentId"
      >
      <span class="field-directions" v-if="directions" v-html="directions"></span>
      <template v-if="showUploader">
        <div class="mt-5">
          <p class="font-weight-bold mb-2">Requirements</p>
          <ul>
            <li>Accepted file types .png and .jpg</li>
            <li>Minimum resolution 650 x 325 px</li>
            <li>Don't use a business logo</li>
            <li>Don't upload photos you don't own or don't have a license for</li>
          </ul>
          <p class="text-caption mt-7">
            We will review the photos that you upload after you submit your
            campaign. Photos that don’t meet Bandwango’s requirements will
            be replaced with a different image.
          </p>
        </div>
        <type-image-upload
            v-if="!loading"
            v-model="uploadedImage"
            :is-admin="innerIsAdmin"
            :is-super-admin="innerIsSuperAdmin"
            :required="!uploadedImage"
            :uniqueId="fieldAssignmentId+'-2'"
            :upload-assignment="uploadAissgnment"
            :upload-assignment-id="uploadAssignmentId"
            class="mt-5"
            max-file-size="5mb"
            min-dimensions="650x325"
            @applied="applyImg()"
        />
        <p
            v-for="(error, idx) in errors"
            :key="`imageError-${idx}`"
            class="error--text"
        >
          {{ error }}
        </p>
      </template>
        <template v-else>
          <p class="mt-4">Current image</p>
          <div style="max-width: 90vw;">
            <v-img
                  contain
                  :max-width="$vuetify.breakpoint.mdAndDown ? 650 : ''"
                  :src="currentImageUrl"
                  :lazy-src="'https://via.placeholder.com/400x300?text=Loading'"
                  alt="currently used business image"
          ></v-img>

          </div>

          <v-btn
                  class="mt-3 mb-14"
                  :block="$vuetify.breakpoint.smAndDown"
                  rounded
                  dark
                  elevation="0"
                  color="bw-secondary"
                  @click="changeImg()"
          >Change image</v-btn>
          <v-checkbox
            v-model="hasMedia"
            class="hidden"
          ></v-checkbox>
        </template>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="label"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="currentImageUrl">
          <v-img
                  :src="currentImageUrl"
                  alt="currently used business image"
          ></v-img>
        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
import formMixin from "../formMixin";
import TypeImageUpload from "./TypeImageUpload";
import TypeReview from "./TypeReview";

export default {
  name: 'TypeImg',
  mixins: [formMixin],
  inheritAttrs: false,
  components: {
    TypeImageUpload,
    TypeReview
  },
  data() {
    return {
      selection: '',
      stockImage: 1,
      uploadedImage: null,
      isUploading: false,
      forceShowUploader: false,
      uploadAissgnment:'',
      uploadAssignmentId:'',
      loading: true,
    }
  },
  methods:{
    applyImg() {
      const media = {
        ...this.uploadedImage[0], ...this.uploadedImage[0].cropperSettings, ...{
          media_id: this.uploadedImage[0].id,
          id: this.currentImageAssignmentId,
          location: this.type_attributes
        }
      };

      if (this.currentImageIdx === -1)
        this.innerValue.push(media);
      else
        this.$set(this.innerValue, this.currentImageIdx, media);

      this.forceShowUploader = false;
      this.innerValue = [...this.innerValue]; // trigger update to form
    },
    changeImg() {
      this.forceShowUploader = true;
      this.uploadedImage = [];
    },
  },
  mounted() {
    this.loading = true;
    if( this.field_path ) {
      this.uploadAissgnment = this.field_path.split('.')[0];
      if( this.injectedGetValue )
        this.uploadAssignmentId = this.injectedGetValue(this.uploadAissgnment+".id");
    }

    setTimeout(() => {
      this.loading = false;
      this.fieldLoaded(); // signal to the form we are loaded
    }, 500);
  },
  computed: {
    defaults() {
      return {
        label: this.innerLabel,
        directions: this.directions,
        persistentHint: true,
      }
    },
    rules() {
      return {
        ...this.validation_settings,
        ...{required: !!this.validation_settings.required && !!this.innerShouldShow}
      }
    },
    showUploader() {
      return this.forceShowUploader || !this.hasMedia || !this.currentImageUrl;
    },
    hasMedia() {
      return this.currentImageIdx > -1
    },
    currentImageIdx() {
      return (this.innerValue || []).findIndex((vm) => this.type_attributes.indexOf(vm.location) > -1)
    },
    currentImageUrl() {
      return this.hasMedia ? this.innerValue[this.currentImageIdx].url : null
    },
    currentImageAssignmentId() {
      return this.hasMedia ? this.innerValue[this.currentImageIdx].id : null
    },
    isUpdating() {
      return this.isUploading
    },
  },
}
</script>
